import Tools from '@/components/tools/Tools.js'

export default {
  name: 'TableSalesReportsAccredited',
  props: ['columns', 'dataEnteprise', 'dataCredenciada', 'i', 'verificarMes', 'dataSales'],
  data () {
    return {
      rows: [],
      totalSaleValue: 0,
      title: 'N/A'
    }
  },
  mounted () {
    let objFilter = {}
    this.title = this.dataSales[0].nomeEmpreendimento
    this.dataSales.forEach(sale => {
      this.totalSaleValue += sale.valorVenda
      if (objFilter[sale.nomeCredenciada] === undefined) {
        objFilter[sale.nomeCredenciada] = {
          nomeCredenciada: sale.nomeCredenciada,
          quantidadeVendas: 1,
          valorTotal: sale.valorVenda
        }
      } else {
        objFilter[sale.nomeCredenciada].quantidadeVendas += 1
        objFilter[sale.nomeCredenciada].valorTotal += sale.valorVenda
      }
    })
    this.rows = Object.values(objFilter)
  },
  methods: {
    formatMoney (value) {
      return Tools.formatMoney(value)
    },
    calcularByProposta (proposta) {
      let total = 0
      if (this.verificarMes === true) {
        proposta = proposta.filter((Element) => new Date(Element.dataVenda).getMonth() === this.i)
        proposta.forEach(element => {
          total += element.valorTotal
        })
      } else {
        proposta.forEach(element => {
          total += element.valorTotal
        })
      }
      return total
    },
    calcularByCredenciada (credenciada) {
      let total = 0
      if (this.verificarMes === true) {
        credenciada.forEach((credenciada) => {
          credenciada.proposta.forEach((proposta) => {
            if (new Date(proposta.dataVenda).getMonth() === this.i) total += proposta.valorTotal
          })
        })
      } else {
        credenciada.forEach((credenciada) => {
          credenciada.proposta.forEach((proposta) => {
            total += proposta.valorTotal
          })
        })
      }
      return total
    },
    calculaSalesEnterprise (credenciada) {
      let total = 0
      if (this.verificarMes === true) {
        credenciada.forEach((credenciada) => {
          credenciada.proposta.forEach((proposta) => {
            if (new Date(proposta.dataVenda).getMonth() === this.i) total++
          })
        })
      } else {
        credenciada.forEach((credenciada) => {
          credenciada.proposta.forEach((proposta) => {
            total++
          })
        })
      }
      return total
    },
    calcularSalesProposta (proposta) {
      let total = 0
      if (this.verificarMes === true) {
        proposta = proposta.filter((Element) => new Date(Element.dataVenda).getMonth() === this.i)
        proposta.forEach(element => {
          total++
        })
      } else {
        proposta.forEach(element => {
          total++
        })
      }
      return total
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/salesbyaccredited/components/tablesalesreportsaccredited/tablesalesreportsaccredited.js